import { ReactNode } from "react";
import { Box, Center, Heading, Icon, Stack, Text } from "@seneca/senekit";

export function UnsubscribeResult({
  heading,
  children,
  isSuccess
}: {
  heading: string;
  children: ReactNode;
  isSuccess: boolean;
}) {
  return (
    <Stack space="xlarge">
      <Center>
        <Box width="72px" height="72px">
          <Icon
            iconName={isSuccess ? "tickCircle" : "exclamationCircle"}
            accessibilityLabel={isSuccess ? "successTick" : "failureWarning"}
            size="fill"
            tone={isSuccess ? "success" : "error"}
          />
        </Box>
      </Center>
      <Heading level={isSuccess ? "3" : "2"} align="center">
        {heading}
      </Heading>
      <Text align="center">{children}</Text>
    </Stack>
  );
}
